import React from "react";
import { Logo } from "@/components/kit";

const cx = (...c) => c.filter(Boolean).join(" ");

const VALUES = [
  { title: "Intentional", sub: "Explore with purpose." },
  { title: "Respectful", sub: "Communicate with clarity." },
  { title: "Authentic", sub: "Be your true self." },
  { title: "Meaningful", sub: "Build real connections." },
];

/* Desktop-only brand panel that fills the extra horizontal space on large screens. */
export const BrandPanel = () => (
  <aside className="hidden lg:flex flex-col justify-between w-[380px] shrink-0 bg-[#253B35] p-11">
    <div className="pt-6">
      <Logo variant="stacked" light className="h-28" />
      <p className="font-sans text-[15px] text-[#C7D1CA] leading-relaxed mt-10 max-w-[260px]">
        A calm, intentional relationship platform for adults seeking something real.
      </p>
    </div>
    <div className="space-y-5">
      {VALUES.map((v) => (
        <div key={v.title} className="border-l border-[#8B9D90]/40 pl-4">
          <p className="font-serif text-lg text-[#F8F6F1] leading-none">{v.title}</p>
          <p className="font-sans text-xs text-[#8B9D90] mt-1">{v.sub}</p>
        </div>
      ))}
    </div>
  </aside>
);

/*
 * Responsive flow shell (welcome, auth, onboarding).
 * - Mobile: full-width ivory column.
 * - Tablet/Desktop: centered rounded surface with a forest brand panel beside the content,
 *   using the available width rather than stretching the mobile UI.
 */
export const MobileShell = ({ children, className = "", hideBrandPanel = false }) => (
  <div className="min-h-[100dvh] w-full bg-[#F8F6F1] lg:bg-[#1E302B] lg:flex lg:items-center lg:justify-center lg:py-10 lg:px-6">
    <div className="w-full lg:w-auto lg:flex lg:rounded-[2.25rem] lg:overflow-hidden lg:shadow-[0_30px_90px_rgba(0,0,0,0.35)] lg:border lg:border-[#F8F6F1]/10">
      {!hideBrandPanel && <BrandPanel />}
      <div
        className={cx(
          "relative w-full max-w-md mx-auto lg:mx-0 lg:w-[460px] bg-[#F8F6F1] min-h-[100dvh] lg:min-h-0 lg:h-[860px] lg:max-h-[90vh] lg:overflow-y-auto no-scrollbar border-x border-[#E3DCD0] lg:border-x-0",
          className
        )}
      >
        {children}
      </div>
    </div>
  </div>
);

export const Header = ({ title, left, right, subtitle }) => (
  <header className="sticky top-0 z-40 bg-[#F8F6F1]/90 backdrop-blur-md border-b border-[#E3DCD0] px-5 py-3.5 flex items-center justify-between">
    <div className="w-10 flex items-center">{left}</div>
    <div className="text-center">
      <h1 className="font-serif text-xl text-[#1F2B26] leading-none">{title}</h1>
      {subtitle && <p className="font-sans text-[11px] text-[#8A9790] mt-0.5">{subtitle}</p>}
    </div>
    <div className="w-10 flex items-center justify-end">{right}</div>
  </header>
);
